import saveAs from '../../../vendor/save-as';
export class CSVHelper {
    static saveCSV(fileName, fileBody) {
        const file = new Blob([fileBody.join('\r\n')], { type: 'text/csv' });
        saveAs(file, `${fileName}.csv`);
    }
    static saveCSVFromBlob(fileName, blob) {
        saveAs(blob, `${fileName}.csv`);
    }
    static escapeString(str) {
        return ('' + str).replace(/["\n\r\u2028\u2029]/g, (char) => {
            switch (char) {
                case '"':
                    return '""';
                case '\n':
                    return '\\n';
                case '\r':
                    return '\\r';
                case '\u2028':
                    return '\\u2028';
                case '\u2029':
                    return '\\u2029';
            }
        });
    }
}
